import React, { createContext, useContext, useEffect, useState } from "react";

const LangContext = createContext({ lang: "en", setLang: () => {} });

export function LangProvider({ children }) {
    const [lang, setLangState] = useState(() => {
        if (typeof window === "undefined") return "en";
        return localStorage.getItem("intol_lang") || "en";
    });
    const setLang = (l) => {
        setLangState(l);
        try {
            localStorage.setItem("intol_lang", l);
        } catch (e) {
            /* ignore */
        }
    };
    useEffect(() => {
        document.documentElement.setAttribute("lang", lang);
    }, [lang]);
    return (
        <LangContext.Provider value={{ lang, setLang }}>
            {children}
        </LangContext.Provider>
    );
}

export const useLang = () => useContext(LangContext);
